import {Injectable} from '@angular/core';
import {Http, URLSearchParams} from '@angular/http';
import {Subject} from 'rxjs/Subject';
import {Observable} from 'rxjs/Observable';
import 'rxjs/add/operator/map';
import 'rxjs/add/operator/debounceTime';
import 'rxjs/add/operator/distinctUntilChanged';
import 'rxjs/add/operator/switchMap';
import {App} from 'ionic-angular';
import {OauthService} from './oauth.service';
import {Search} from '../models/search/search.model';
import {ToolsService} from './tools.service';
import {HttpParams} from '@angular/common/http';
import {AppProvider} from "../../core/app/app-provider.service";

@Injectable()
export class ProduitsService extends OauthService {

  public loader = new Subject<boolean>();

  constructor(
    protected http: Http,
    protected app: App,
    protected appProvider: AppProvider,
    public readonly tools: ToolsService,
  ) {
    super(http, app, appProvider, tools);
    this.loader.next(true); // init custom loader
  }

  getAll(id: string, search: Observable<Search> = null, limit: number = 10, offset: number = null, beneficiaire: number = null) {
    return search.debounceTime(500)
      .distinctUntilChanged()
      .switchMap(s => this.search(id, s.term, s.action, s.limit, s.offset, s.order, s.orderBy, s.startDate, s.endDate, s.familleIds, beneficiaire));
  }

  search(id: string, search: string, action: string, limit: number = 10, offset: number = null,
    order: string = null, orderBy: string = null, startDate: string = null, endDate: string = null,
    familleIds: Array<String> = null, beneficiaire: number = null) {

    this.loader.next(true);

    const param = {'_format': 'json'};

    if (action !== 'scroll') {
      this.loader.next(true); // enable custom loader
    }

    if (id) {
      param['activiteId'] = id;
    }

    if (search) {
      param['search'] = search;
    }

    if (startDate) {
      param['startDate'] = startDate;
    }

    if (endDate) {
      param['endDate'] = endDate;
    }

    if (offset) {
      param['offset'] = offset;
    }

    if (limit) {
      param['limit'] = limit;
    }

    if (orderBy) {
      param['orderBy'] = orderBy;
    }

    if (order) {
      param['withClos'] = order;
    }

    if (familleIds) {
      param['familleIds'] = familleIds;
    }

    if (beneficiaire) {
      param['beneficiaire'] = beneficiaire;
    }

    const url = this.Routing.generate('api_get_produits_produit_articles', param, true);

    return this.http
      .get(url, {headers: this.updateHeaders()})
      .map(response => {
        this.loader.next(false); // disable custom loader
        return {data: response.json().data, action};
      });
  }

  getAllV2(search: Observable<Search> = null, limit: number = 10, offset: number = null, beneficiaire: number = null) {
    return search.debounceTime(500)
      .distinctUntilChanged()
      .switchMap(s => {
        console.log(s);
        return this.searchV2(s.activiteIds, s.term, s.action, s.limit, s.offset, s.typeActivite, s.order, s.orderBy, s.startDate, s.endDate, s.familleIds, s.departementIds, beneficiaire, s.latitude, s.longitude, s.top);
      });
  }

  searchV2(activiteIds: Array<String> = null, search: string, action: string, limit: number = 10, offset: number = null,
           typeActivite: string = null, order: string = null, orderBy: string = null, startDate: string = null, endDate: string = null,
          familleIds: Array<String> = null, departementIds: Array<String> = null, beneficiaire: number = null, latitude: number = null, longitude: number = null, top: string = null) {

    const param = {'_format': 'json'};

    if (action !== 'scroll') {
      this.loader.next(true); // enable custom loader
    }

    if (activiteIds) {
      param['activiteIds'] = activiteIds;
    }

    if (search) {
      param['search'] = search;
    }

    if (typeActivite && typeActivite !== '') {
      param['typeActivite'] = typeActivite;
    }

    if (startDate) {
      param['startDate'] = startDate;
    }

    if (endDate) {
      param['endDate'] = endDate;
    }

    if (offset) {
      param['offset'] = offset;
    }

    if (limit) {
      param['limit'] = limit;
    }

    if (orderBy) {
      param['orderBy'] = orderBy;
    }

    if (latitude) {
      param['latitude'] = latitude;
    }

    if (longitude) {
      param['longitude'] = longitude;
    }

    if (order) {
      param['withClos'] = order;
    }

    if (familleIds) {
      param['familleIds'] = familleIds;
    }

    if (departementIds) {
      param['codes'] = departementIds;
    }

    if (beneficiaire) {
      param['beneficiaireId'] = beneficiaire;
    }

    if (top === 'true') {
      param['top'] = top;
    }

    const url = this.Routing.generate('api_get_produits_produit_articles_v2', param, true);

    return this.http
      .get(url, {headers: this.updateHeaders()})
      .map(response => {
        this.loader.next(false); // disable custom loader
        return {data: response.json().data, action};
      });
  }

  getProduit(id: string, sourceDeDonnees: string = null) {
    const param = {'_format': 'json', 'produit': id};
    const url = this.Routing.generate('api_get_produit', param, true);

    let params = new URLSearchParams();
    if (sourceDeDonnees) {
      params.set('sourceDeDonnees', sourceDeDonnees);
    }

    return this.http
      // .get(`${url}/${id}`, { params: params, headers: this.updateHeaders()})
      .get(`${url}`, { params: params, headers: this.updateHeaders()})
      .map(response => {
        // this.loader.next(false); // enable custom loader
        return response.json().data;
      });
  }

  getArticlesByProduit(id: string) {
    const url = this.Routing.generate('api_get_articles', {'_format': 'json'}, true);
    const params = new URLSearchParams();

    params.set('produitId', id.toString());

    return this.http
      .get(url, {search: params, headers: this.updateHeaders()})
      .map(response => {
        // this.loader.next(false); // disable custom loader
        return response.json().data;
      });
  }

  getFirstArticle(id: string) {
    const url = this.Routing.generate('api_get_article', {'_format': 'json', 'article': id}, true);
    const params = new URLSearchParams();

    return this.http
      // .get(`${url}/${id}`, {search: params, headers: this.updateHeaders()})
      .get(`${url}`, {search: params, headers: this.updateHeaders()})
      .map(response => response.json().data);
  }

  public getActivite(id: number) {
    const url = this.Routing.generate('api_get_produit_activite', {
      '_format': 'json',
      'produit': id.toString()
    }, true);

    return this.http
      .get(url, {headers: this.updateHeaders()})
      .map(response => {
        return response.json().data;
      });
  }

  public setAfficheCe(idProduit: number, isAfficheCe: boolean) {
    let isAfficheCeNumeric = isAfficheCe ? 1 : 0;
    const url = this.Routing.generate('api_put_produit_affichage_ce', {
      '_format': 'json',
      'produit': idProduit,
      'isAfficheCe': isAfficheCeNumeric
    }, true);

    return this.http
      .put(url, null, {headers: this.updateHeaders()})
      .map(response => response.json());

  }

  public getAjoutSansSubventionPossible(idProduit: string | number, sourceDeDonnees: string) {
    const url = this.Routing.generate('api_get_produit_ajout_sans_subvention', {
      '_format': 'json',
      'produit': idProduit.toString(),
      'sourceDeDonnees': sourceDeDonnees
    }, true);

    return this.http
      .get(url, {headers: this.updateHeaders()})
      .map(response => {
        return response.json();
      });
  }

}



// WEBPACK FOOTER //
// ./src/shared/services/produits.service.ts